import Group from 'vux/src/components/group/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'

import CryptoJS from "crypto-js"
import { mapActions, } from 'vuex'
export default {
name: 'personalData',
directives: {
TransferDom
},
components: {
Datetime,
Group,
Cell,
XButton,
PopupRadio,
Popup,
Confirm
},
data () {
return {
sexOption: ['男', '女', '保密'],
myInfo: {},
showEdit: false,
showChangePhone: false,
showChangePsd: false,
changePsdModule: {
showModule: 'selectMethods',
},
showRelieveBindQQConfirm: false,
phoneReg: /^1[3456789]\d{9}$/,  //手机号正则
phoneStep: {
first: true,
second: false,
newPhone: '',
verificationCode: '',
timerText: '',
isGetCode: true,
},
changePsdData: {
nowPsd: '',
newPsd: '',
againPsd: '',
},
editTitle: '',
editText: '',
editEvent: '',
desUtil: {

_key: "F9387E75D65343CA87103DE403D7CDBFB7F0163776164FEC956406DB2DBD401D",

_type: 1,

encrypt: function(message) {
var key = this._key;
var keyHex = CryptoJS.enc.Utf8.parse(key);
var encrypted = CryptoJS.DES.encrypt(message, keyHex, {
mode: CryptoJS.mode.ECB,
padding: CryptoJS.pad.Pkcs7
});
var result = "";
switch (this._type.toString()) {
case "1":

result = encrypted.ciphertext.toString(CryptoJS.enc.Hex);
console.log(result);

break;
}
return result;
}
},
password: '',
showQuitConfirm: false,
types: [
{
psdType: 'password',
psdIcon: require('../../assets/images/showPsd.png'),
},
{
psdType: 'password',
psdIcon: require('../../assets/images/showPsd.png'),
},
{
psdType: 'password',
psdIcon: require('../../assets/images/showPsd.png'),
},
],
}
},
methods: {
...mapActions ([
'actionsUserData'
]),
setCookie(cname, cvalue, exdays) {



var d = new Date();
d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
var expires = "expires=" + d.toUTCString();
document.cookie = cname + "=" + cvalue + "; " + expires+"; path=/"   
console.log(d)
},
getMyInfo () {
this.$request.post('/user/getMyOrderInfo',{

}).then(data => {
if(data.code == 0){
this.myInfo = {...data.obj,token: this.$token}
this.setCookie('_userImg',data.obj.imagePath,0.288)
if(!this.$trim(this.myInfo.qqName)){
this.myInfo.isBind = false
}else{
this.myInfo.isBind = true
}
if(!this.myInfo.imagePath){
this.myInfo.imagePath = require('../../assets/images/person.png')
}
switch (this.editEvent) {
case 'uploadImg':
this.$vux.toast.show({
type: 'success',
text: '头像更换成功'
})
break;
case 'editNickName':
this.$vux.toast.show({
type: 'success',
text: '昵称修改成功'
})
break;
case 'editEmail':
this.$vux.toast.show({
type: 'success',
text: '邮箱修改成功'
})
break;
case 'editPhone':
this.$vux.toast.show({
type: 'success',
text: '手机号修改成功'
})
break;
case 'editPsd':
this.$vux.toast.show({
type: 'success',
text: '密码修改成功'
})
break;
case 'default':
this.$vux.toast.show({
type: 'success',
text: '修改成功'
})
break;
}
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
getProvince () {
var p = new Promise((resolve, reject) => {
var adddress = '',
province = '',
loadScript;
function loadJS(url) { //加载js
loadScript = document.createElement("script");
loadScript.type = "text/javascript";
loadScript.src = url;
document.body.appendChild(loadScript);
}
loadJS("https://pv.sohu.com/cityjson?ie=utf-8");
loadScript.onload = function () {

adddress = returnCitySN["cname"]


if(adddress.split('省').length != 1) {
province = adddress.split('省')[0]+'省'
}else if(adddress.split('区').length != 1){
province = adddress.split('区')[0]+'区'
}else{
province = adddress.split('市')[0]+'市'
}
resolve(province)
}
})
return p
},
phoneLoginFun (data) {
this.$request.post('/user/bindQQ',data,).then(data => {
if(data.code == 0){   //成功
this.getMyInfo()
this.$vux.toast.show({
type: 'success',
text: '已绑定QQ'
})

this.$route.query.type == ''
window.history.replaceState(null,null,window.location.origin+'/#/personalData')
}else{    //否则
window.history.replaceState(null,null,window.location.origin+'/#/personalData')
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
window.history.replaceState(null,null,window.location.origin+'/#/personalData')
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: e
})
})
},
toggleBindQQ () {
let that = this,
access_token = this.$route.query.accessToken,
openId = this.$route.query.openId,
nickname = this.$route.query.nickname;

this.$request.post('/user/getMyOrderInfo',{

}).then(data => {
if(data.code == 0){
that.getProvince().then((province) => {
let datas = {
openId,
province,
phone: data.obj.phone,
qqName: decodeURIComponent(nickname)
}
that.phoneLoginFun(datas)
})
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})

















},
bindQQ () {   //绑定




if (typeof localStorage === 'object') {
try {
localStorage.setItem('localStorage', 1);
localStorage.removeItem('localStorage');
} catch (e) {
Storage.prototype._setItem = Storage.prototype.setItem;
Storage.prototype.setItem = function() {};
alert('您处于无痕浏览，无法为您绑定QQ');
return false;
}
}

let myUrl = encodeURIComponent('https://www.qsy3d.com/mobileLogin/mobileLogin.html'),
backUrl = encodeURIComponent(location.origin+'/#/loginTransfers?type=bind&token='+this.$common.getCookie('_token'));


location.href = 'https://graph.qq.com/oauth2.0/authorize?response_type=token&client_id=101811587&redirect_uri='+myUrl+'&state='+backUrl
},
relieveBindQQ () {  //解除绑定
this.$request.post('/user/relieveBindQQ',{}).then(data => {
if(data.code == 0){
this.getMyInfo()
this.$vux.toast.show({
type: 'success',
text: '已解除绑定'
})
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
getCodeFun () {   //获取验证码的函数
this.$request.post('/message/verificationCode',{
phone: this.$trim(this.phoneStep.newPhone)
}).then(data => {
console.log(data)
}).catch(e => {
console.log(e)
})
},
updateMyInfo () {
let formData = new FormData();
if(!!this.myInfo.birthday){
formData.append('birthday', this.myInfo.birthday);
}
formData.append('mail', this.myInfo.mail);
if(!!this.myInfo.sex){
formData.append('sex', this.myInfo.sex);
}
if(!!this.myInfo.nickName){
formData.append('nickName', this.myInfo.nickName);
}
formData.append('myfile', this.myInfo.myfile);
this.$request.post('/user/updateMyOrderInfo',formData).then(data => {
if(data.code == 0){
this.showEdit = false
this.getMyInfo()
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
selectSex () {
this.editEvent = ''
this.updateMyInfo()
},
nickName () {
this.editTitle = '修改昵称'
this.editText = this.myInfo.nickName
this.showEdit = true
this.editEvent = 'editNickName'
},
Email () {
this.editTitle = '修改邮箱'
this.editText = this.myInfo.mail
this.showEdit = true
this.editEvent = 'editEmail'
},
birthday () {
this.editEvent = 'default'
this.updateMyInfo()
},
handleFile (e) {
let file = e.target.files[0]
this.editEvent = 'uploadImg'
this.myInfo.myfile = file
this.updateMyInfo()
},
showChangePhoneEvent () {
this.showChangePhone = true
this.password = ''
this.types[0].psdType = 'password'
this.types[0].psdIcon = require('../../assets/images/showPsd.png')
},
showChangePsdEvent () {
this.showChangePsd = true
this.changePsdModule.showModule = 'selectMethods'
this.phoneStep.newPhone = ''
this.phoneStep.verificationCode = ''
this.changePsdData = {
nowPsd: '',
newPsd: '',
againPsd: '',
}
this.types[0].psdType = 'password'
this.types[0].psdIcon = require('../../assets/images/showPsd.png')
this.types[1].psdType = 'password'
this.types[1].psdIcon = require('../../assets/images/showPsd.png')
this.types[2].psdType = 'password'
this.types[2].psdIcon = require('../../assets/images/showPsd.png')
},
nextStep () {
if(!this.password){
this.$vux.toast.show({
type: 'warn',
text: '请输入密码'
})
return false;
}

let _password = this.desUtil.encrypt(this.password);

this.$request.post('/user/verifyPsw',{
userPassword: _password
}).then(data => {
if(data.code == 0){
this.phoneStep.first = false
this.phoneStep.second = true
this.phoneStep.newPhone = ''
this.phoneStep.verificationCode = ''
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
getCode () {
if(!this.phoneReg.test(this.phoneStep.newPhone)){
this.$vux.toast.show({
type: 'warn',
text: '手机号码格式错误'
})
return false;
}
this.getCodeFun()
this.phoneStep.isGetCode = false
let codeTimer = 60
this.phoneStep.timerText = codeTimer-- + 's 后重新获取'
let timeOutFn = setInterval(() => {
this.phoneStep.timerText = codeTimer-- + 's 后重新获取'
if(codeTimer == -1){
codeTimer = 60
clearInterval(timeOutFn)
this.phoneStep.isGetCode = true
}
}, 1000);
},
phoneUpdateFun (datas) {
this.$request.post('/user/updatePhone',datas).then(data => {
if(data.code == 0){
this.editEvent = 'editPhone'
this.showChangePhone = false
this.updateMyInfo()
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
this.$vux.toast.show({
type: 'cancel',
text: e.msg
})

})
},
togglePsdType (i) {
console.log(i)
if(this.types[i].psdType == 'password'){
this.types[i].psdType = 'text'
}else{
this.types[i].psdType = 'password'
}
if(this.types[i].psdType == 'password'){
this.types[i].psdIcon = require('../../assets/images/showPsd.png')
}else{
this.types[i].psdIcon = require('../../assets/images/hidePsd.png')
}
},
finish () {
let datas = {
phone: this.phoneStep.newPhone,
verificationCode: this.phoneStep.verificationCode
}






this.phoneUpdateFun(datas)











},
phonePrevStep () {
this.phoneStep.first = true
this.phoneStep.second = false
},
changePsdFun (datas) {
this.$request.post('/user/updatePsw',datas).then(data => {
if(data.code == 0){
this.editEvent = 'editPsd'
this.showChangePsd = false
this.updateMyInfo()
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
changePsdByPsd () {
if(!this.changePsdData.nowPsd){
this.$vux.toast.show({
type: 'warn',
text: '请输入当前密码'
})
return false;
}
if(!this.changePsdData.newPsd){
this.$vux.toast.show({
type: 'warn',
text: '请输入新密码'
})
return false;
}
if(this.changePsdData.newPsd.length < 6){
this.$vux.toast.show({
type: 'warn',
text: '密码长度不能小于6位数'
})
return false;
}
if(!this.changePsdData.againPsd){
this.$vux.toast.show({
type: 'warn',
text: '请确认新密码'
})
return false;
}
if(this.changePsdData.againPsd.length < 6){
this.$vux.toast.show({
type: 'warn',
text: '密码长度不能小于6位数'
})
return false;
}
if(this.changePsdData.newPsd != this.changePsdData.againPsd){
this.$vux.toast.show({
type: 'warn',
text: '新密码不一致'
})
return false;
}

let _password = this.desUtil.encrypt(this.changePsdData.nowPsd);
let datas = {
userPassword: this.desUtil.encrypt(this.changePsdData.newPsd)
}
this.$request.post('/user/verifyPsw',{
userPassword: _password
}).then(data => {
data.code == 0
? this.changePsdFun(datas)
: this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}).catch(e => {
console.log(e)
})
},
changePsdByPhone () {
let datas = {
phone: this.phoneStep.newPhone
}






if(this.changePsdData.newPsd.length < 6){
this.$vux.toast.show({
type: 'warn',
text: '密码长度不能小于6位数'
})
return false;
}
if(!this.changePsdData.againPsd){
this.$vux.toast.show({
type: 'warn',
text: '请确认新密码'
})
return false;
}
if(this.changePsdData.againPsd.length < 6){
this.$vux.toast.show({
type: 'warn',
text: '密码长度不能小于6位数'
})
return false;
}
if(this.changePsdData.newPsd != this.changePsdData.againPsd){
this.$vux.toast.show({
type: 'warn',
text: '两次密码不一致'
})
return false;
}

let that=this

console.log('asdasdasds');
this.$request.post('/user/updatePwdByPhone',{
phone: this.phoneStep.newPhone,
password: this.desUtil.encrypt(this.changePsdData.newPsd),
verificationCode:this.phoneStep.verificationCode
}).then(data => {
console.log('data.code',data);
if(data.code == 0){
console.log('data.code',data.msg);



this.editEvent = 'editPsd'
this.showChangePsd = false
this.updateMyInfo()

}else{
console.log('data.code2',data.msg);
that.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
that.$vux.toast.show({
type: 'cancel',
text: e.msg
})
})












},
editData () {
if(this.editEvent == 'editNickName'){
this.myInfo.nickName = this.editText
}else if(this.editEvent == 'editEmail'){
var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
if (!reg.test(this.editText)) {
this.$vux.toast.show({
type: 'warn',
text: '邮箱格式错误'
})
return false;
}
this.myInfo.mail = this.editText
}
this.updateMyInfo()
},
onConfirm () {

this.setCookie('_token', "", -1)
this.setCookie('_isMonthlyKnots', "", -1)
this.setCookie('_userImg', "", -1)
this.$store.dispatch('actionsUserData','')

this.$token = null
this.$router.push({
path: '/'
})
},
logoutAccount () {
this.$request.post('/user/selectLogoutExamine',{

}).then(data => {
if(data.code == 0){
if(!data.obj){
this.$router.push({
path: '/logoutApply'
})
}else{
this.$router.push({
path: '/logoutVerify'
})
}
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}
},
created () {
this.getMyInfo()
},
mounted() {



if(this.$route.query.types == 'bindQQFlag' && this.$route.query.hasBind == false){
this.toggleBindQQ()
}else if(this.$route.query.types == 'bindQQFlag' && this.$route.query.hasBind == true){
this.$vux.toast.show({
type: 'warn',
text: '该QQ已被其他账号绑定',

})
window.history.replaceState(null,null,window.location.origin+'/#/personalData')
}
}
}



// WEBPACK FOOTER //
// ./src/views/personalData/script.js